import { Pipe, PipeTransform } from '@angular/core';
import { AttachmentType } from 'it/primatoo/openapi/api/org/schemas/common/AttachmentType';


@Pipe({
  name: 'attachmentType',
  pure: false
})

export class AttachmentTypePipe implements PipeTransform {

  private type = AttachmentType

  transform(file: string): string {
    if (file) {
      const fileSplit = file.split('.');
      const fileType = fileSplit[fileSplit.length - 1];
      if (fileType.toUpperCase() in AttachmentType) {
        return `${fileType}.svg`;
      }
      return `attachment.svg`;
    }
    return;
  }
}
